import {
  Card,
  CardHeader,
  Container,
  Divider,
  Table,
  TableBody,
  TableContainer,
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import AppLoadingAndErrorWrapper from 'src/components/common/AppLoadingAndErrorWrapper';
import FormProvider from 'src/components/hook-form/form-provider';
import Scrollbar from 'src/components/scrollbar';
import { TableHeadCustom, TablePaginationCustom, TableSkeleton } from 'src/components/table';
import AppTableToolbar from 'src/components/table/AppTableToolbar';
import { Order_By } from 'src/graphql';
import ADSRow from './ads-row';
import useAds from './use-ads';
import { ADS_TABLE_HEAD } from 'src/constants/tables-heads';
import { paths } from 'src/routes/paths';

export type ADSsFormType = {
  sortBy: string | undefined;
  sortDirection: Order_By.Asc | Order_By.Desc | undefined;
};

type ADSsPropsType = {
  title?: string;
};

const Ads = ({ title }: ADSsPropsType) => {
  const {
    data,
    handleDeleteADS,
    handleSearch,
    isDeleting,
    isLoading,
    methods,
    query,
    setQuery,
    t,
    table,
  } = useAds();

  const viewComponent = (
    <AppLoadingAndErrorWrapper isLoading={isDeleting} errorMessage={null}>
      {!title && (
        <Helmet>
          <title>{t('sidebar.ads')}</title>
        </Helmet>
      )}
      <Card>
        {title && <CardHeader title={title} />}
        {title && <Divider sx={{ mt: 3 }} />}
        <FormProvider methods={methods}>
          <AppTableToolbar
            handleSearch={handleSearch}
            search={query.search!}
            tableName=""
            buttons={[
              {
                path: paths.dashboard.contentManagement.ads.addAds,
                permissionName: undefined,
              },
            ]}
          />
          <TableContainer>
            <Scrollbar>
              <Table>
                <TableHeadCustom
                  setQuery={setQuery}
                  headLabel={ADS_TABLE_HEAD(t)}
                  methods={methods}
                />
                <TableBody>
                  {isLoading || isDeleting ? (
                    [...Array(table.rowsPerPage)].map((i, index) => (
                      <TableSkeleton key={index} sx={{ height: 80 }} />
                    ))
                  ) : (
                    <>
                      {data?.ads?.map((row) => (
                        <ADSRow key={row.id} row={row} deleteHandler={handleDeleteADS} />
                      ))}
                    </>
                  )}
                </TableBody>
              </Table>
            </Scrollbar>
          </TableContainer>
          {data && (
            <TablePaginationCustom
              count={+data.ads_aggregate.aggregate?.count!}
              page={+table.page}
              rowsPerPage={table.rowsPerPage}
              onPageChange={table.onChangePage}
              onRowsPerPageChange={table.onChangeRowsPerPage}
            />
          )}
        </FormProvider>
      </Card>
    </AppLoadingAndErrorWrapper>
  );

  return title ? viewComponent : <Container>{viewComponent}</Container>;
};

export default Ads;
